import React, { useEffect, useState } from "react";
import { useDroppable } from "@dnd-kit/core";
import { useDndContext } from "@dnd-kit/core";

interface IframeDropZoneProps {
    children?: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
}

export default function IframeDropZone({
    children,
    className = "",
    style: externalStyle,
}: IframeDropZoneProps) {
    const { isOver, setNodeRef } = useDroppable({
        id: "iframe-drop-zone",
    });

    // Track if any item is being dragged
    const dndContext = useDndContext();
    const isDragging = !!dndContext.active;

    const style = {
        ...externalStyle,
        opacity: isOver ? 0.8 : 1,
        transition: "opacity 200ms ease-in-out",
    };

    return (
        <div ref={setNodeRef} style={style} className={`relative ${className}`}>
            {children}
            {/* Overlay to catch mouse events when dragging over iframe */}
            {isDragging && (
                <div
                    className="absolute inset-0 z-[9999]"
                    style={{
                        backgroundColor: "transparent",
                        cursor: "grabbing",
                    }}
                />
            )}
            {/* Drop indicator */}
            {isOver && (
                <div
                    className="absolute inset-0 border-1 border-dashed flex items-center justify-center pointer-events-none z-[10000]"
                    style={{
                        backgroundColor: "rgba(172, 140, 247, 0.2)",
                        borderColor: "rgba(139, 92, 246, 1)",
                    }}></div>
            )}
        </div>
    );
}
